import _ from 'lodash'
import React, { PureComponent } from 'react'

import { createStyles, TextField, Theme } from '@mui/material'
import { withStyles, WithStyles } from '@mui/styles'

class PeopleTextFilter extends PureComponent<PeopleTextFilterProps & WithStyles<typeof styles>> {
  constructor(props: PeopleTextFilterProps & WithStyles<typeof styles>) {
    super(props)
    this.handleSearchChange = this.handleSearchChange.bind(this)
    this.propagateChange = _.debounce(this.propagateChange.bind(this), 250)
  }

  handleSearchChange(event: React.ChangeEvent<HTMLInputElement>) {
    this.propagateChange(event.target.value)
  }

  // We need to encapsulate the change, since event.target doesn't play well with debouncing
  propagateChange(search: string) {
    const { onChangeSearch } = this.props
    onChangeSearch(search)
  }

  render() {
    const { classes } = this.props
    return (
      <TextField
        placeholder="First name, last name or email"
        // Inheriting the value from the redux store seems to be slow, we can use the local state here for performance reasons
        // value={search}
        onChange={this.handleSearchChange}
        className={classes.field}
      />
    )
  }
}

export type PeopleTextFilterProps = {
  search: string
  onChangeSearch: (newSearch: string) => void
}

const styles = ({ spacing }: Theme) =>
  createStyles({
    field: {
      width: spacing(38),
      marginRight: spacing(2),
    },
  })

export default withStyles(styles)(PeopleTextFilter)
